"use strict";
// (C) 2020-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInvalidAttributeDisplayFormIdentifiers = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
var types_1 = require("../../../../drill/types");
var model_1 = require("../../../../../model");
var react_1 = require("react");
function useInvalidAttributeDisplayFormIdentifiers(urlDrillTarget, attributes) {
    var displayForms = model_1.useDashboardSelector(model_1.selectAllCatalogDisplayFormsMap);
    return react_1.useMemo(function () {
        if (types_1.isDrillToCustomUrlConfig(urlDrillTarget)) {
            var parameters = getAttributeIdentifiersPlaceholdersFromUrl(urlDrillTarget.customUrl);
            return parameters
                .filter(function (_a) {
                var identifier = _a.identifier;
                // parameter is invalid if either it points to display form that no longer exists
                var relevantDf = displayForms.get(sdk_model_1.idRef(identifier, "displayForm"));
                if (!relevantDf) {
                    return false;
                }
                // or if it points to an attribute that is no longer a valid drill target
                return !attributes.some(function (attribute) {
                    return sdk_model_1.areObjRefsEqual(relevantDf.attribute, attribute.attributeHeader.formOf);
                });
            })
                .map(function (_a) {
                var identifier = _a.identifier;
                return identifier;
            });
        }
        return [];
    }, [displayForms, urlDrillTarget, attributes]);
}
exports.useInvalidAttributeDisplayFormIdentifiers = useInvalidAttributeDisplayFormIdentifiers;
var getAttributeIdentifiersPlaceholdersFromUrl = function (url) {
    return matchAll(/\{attribute_title\((.*?)\)\}/g, url).map(function (match) { return ({
        placeholder: match[0],
        identifier: match[1],
        toBeEncoded: match.index !== 0,
    }); });
};
function matchAll(regex, text) {
    var matches = [];
    var match = null;
    while ((match = regex.exec(text)) !== null) {
        matches.push(match);
    }
    return matches;
}
//# sourceMappingURL=useInvalidAttributeDisplayFormIdentifier.js.map